import React from 'react';
import $ from 'jquery';
import FeedItem from './Feeds/Item';


class Feeds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            element_height: 0
        };
        this.height = 0;
        this.stop_scroll = false;
        this.prev_scroll = 0;
        this.updatedReload = false;
        window.canTouchElement = true;
    }

    componentDidMount() {
        window.lockTouch = false;
    }


    componentDidUpdate() {

    }

    componentWillReceiveProps() {
        this.stop_scroll = true;

    }

    __scrollHandler(event) {
        let offset = event.target.scrollHeight - event.target.clientHeight;

        this.props.updateScroll(event.target.scrollTop);

        if(event.target.scrollTop < this.prev_scroll) {
            $('.m2content__header').addClass('fixed_header');
            this.prev_scroll = event.target.scrollTop;
        } else {
            $('.m2content__header').removeClass('fixed_header');
            this.prev_scroll = event.target.scrollTop;
        }

        if(event.target.scrollTop == 0) {
            $('.m2content__header').removeClass('fixed_header');
        }


        clearTimeout(window.canTouchElementTimeout);
        window.canTouchElement = false;
        window.canTouchElementTimeout = setTimeout(function() {
            window.canTouchElement = true;
        }, 700);



        if(event.target.scrollTop >= offset) {
            this.stop_scroll = true;
            this.props.incPage();
        }
    }

    render() {

        return (
            <div className="m2feeds__list" onScroll={this.__scrollHandler.bind(this)}>
                {this.props.items && this.props.items.length > 0 && this.props.items.map(item => <FeedItem addBookmark={this.props.bookmark} select={this.props.select} more={this.props.moreHandler} key={"feed_item_" + item.id} {...item}/>)}
                {(!this.props.items || this.props.items.length == 0) && <div className="m2feed_feed_loading m2loading"></div>}
            </div>
        );
    }
}

export default Feeds;


// WEBPACK FOOTER //
// ./src/components/Feeds.js